export function mmToPx(mm: number): number {
  return mm * 3.7795275591;
}
